import { getSubject, Subjects } from "src/services/AppAbility";
import { RouteRecordRaw } from "vue-router";

declare module "vue-router" {
  interface RouteMeta {
    requiresAuth: boolean;
    subject: Subjects;
    storeHistory?: boolean;
  }
}

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "Home" },
    children: [
      {
        name: getSubject("Home"),
        path: "",
        component: () => import("pages/index.vue"),
      },
      {
        name: getSubject("My Profile"),
        path: "/profile",
        meta: { requiresAuth: true, subject: "My Profile" },
        component: () => import("pages/myProfile/index.vue"),
      },
    ],
  },

  {
    path: "/auth",
    component: () => import("layouts/LoginLayout.vue"),
    meta: { requiresAuth: false, subject: "Login" },
    children: [
      {
        name: getSubject("Login"),
        meta: { requiresAuth: false, subject: "Login" },
        path: "/auth/login",
        component: () => import("pages/login/index.vue"),
      },
    ],
  },

  {
    path: "/orders",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "Orders" },
    children: [
      {
        name: getSubject("Orders"),
        path: "",
        meta: { requiresAuth: true, subject: "Orders" },
        component: () => import("pages/orders/index.vue"),
      },
      {
        name: getSubject("OrderDetails"),
        path: "details",
        meta: { requiresAuth: true, subject: "OrderDetails" },
        component: () => import("src/pages/orders/Details.vue"),
      },
      {
        name: getSubject("OrdersQueued"),
        path: "queued",
        meta: { requiresAuth: true, subject: "OrdersQueued" },
        component: () => import("src/pages/orders/Queued.vue"),
      },
    ],
  },

  {
    path: "/api",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "Api" },
    children: [
      {
        name: getSubject("Api"),
        path: "",
        component: () => import("pages/api/index.vue"),
      },
    ],
  },
  {
    path: "/tasks",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "Tasks" },
    children: [
      {
        name: getSubject("Tasks"),
        path: "",
        component: () => import("pages/tasks/index.vue"),
      },
    ],
  },

  {
    path: "/factories",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "Factories" },
    children: [
      {
        name: getSubject("Factories"),
        path: "",
        component: () => import("pages/factories/index.vue"),
      },
    ],
  },
  {
    path: "/factories/zf/cockpits/AR",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZF AR" },
    children: [
      {
        name: getSubject("ZF AR"),
        path: "",
        component: () => import("src/pages/factories/zf/cockpits/AR/index.vue"),
      },
    ],
  },
  {
    path: "/factories/zh/mabo-pp-buffer",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZH Stelling PP" },
    children: [
      {
        name: getSubject("ZH Stelling PP"),
        path: "",
        component: () =>
          import("src/pages/factories/zh/mabo-buffer-pp/index.vue"),
      },
    ],
  },
  {
    path: "/factories/zh/dashboard",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZH Dashboard" },
    children: [
      {
        name: getSubject("ZH Dashboard"),
        path: "",
        component: () => import("src/pages/factories/zh/dashboard/index.vue"),
      },
    ],
  },
  {
    path: "/factories/zh/settings",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZH Settings" },
    children: [
      {
        name: getSubject("ZH Settings"),
        path: "",
        component: () => import("src/pages/factories/zh/settings/index.vue"),
      },
    ],
  },
  {
    path: "/factories/zh/cockpits/preparePP",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZH PreparePP" },
    children: [
      {
        name: getSubject("ZH PreparePP"),
        path: "",
        component: () =>
          import("src/pages/factories/zh/cockpits/preparePP/index.vue"),
      },
    ],
  },
  {
    path: "/factories/ee",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "EE Dashboard" },
    children: [
      {
        name: getSubject("EE Dashboard"),
        path: "",
        component: () => import("src/pages/factories/ee/index.vue"),
      },
    ],
  },
  {
    path: "/factories/ee/batches",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "EE Batches" },
    children: [
      {
        name: getSubject("EE Batches"),
        path: "",
        component: () => import("src/pages/factories/ee/batches/index.vue"),
      },
    ],
  },
  {
    path: "/factories/ee/tasks",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "EE Tasks" },
    children: [
      {
        name: getSubject("EE Tasks"),
        path: "",
        component: () => import("src/pages/factories/ee/tasks/index.vue"),
      },
    ],
  },
  {
    path: "/factories/ee/settings",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "EE Settings" },
    children: [
      {
        name: getSubject("EE Settings"),
        path: "",
        component: () => import("src/pages/factories/ee/settings/index.vue"),
      },
    ],
  },
  {
    path: "/factories/zf/cockpits/LuxeLineAssembly",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZF Luxe-Line Assembly" },
    children: [
      {
        name: getSubject("ZF Luxe-Line Assembly"),
        path: "",
        component: () =>
          import("src/pages/factories/zf/cockpits/LuxeLineAssembly/index.vue"),
      },
    ],
  },
  {
    path: "/factories/zf/cockpits/PassdoorAssembly",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZF Passdoor Assembly" },
    children: [
      {
        name: getSubject("ZF Passdoor Assembly"),
        path: "",
        component: () =>
          import("src/pages/factories/zf/cockpits/PassdoorAssembly/index.vue"),
      },
    ],
  },
  {
    path: "/factories/zf/cockpits/PP",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZF PP" },
    children: [
      {
        name: getSubject("ZF PP"),
        path: "",
        component: () => import("src/pages/factories/zf/cockpits/PP/index.vue"),
      },
    ],
  },
  {
    path: "/factories/zf/cockpits/preparePaintPP",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZF PreparePaintPP" },
    children: [
      {
        name: getSubject("ZF PreparePaintPP"),
        path: "",
        component: () =>
          import("src/pages/factories/zf/cockpits/preparePaintPP/index.vue"),
      },
    ],
  },
  {
    path: "/factories/zf/cockpits/powderCoating",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZF Powder Coating" },
    children: [
      {
        name: getSubject("ZF Powder Coating"),
        path: "",
        component: () =>
          import("src/pages/factories/zf/cockpits/powderCoating/index.vue"),
      },
    ],
  },
  {
    path: "/factories/zf/cockpits/saws/infeed",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZF Saw infeed" },
    children: [
      {
        name: getSubject("ZF Saw infeed"),
        path: "",
        component: () =>
          import("src/pages/factories/zf/cockpits/saws/infeed.vue"),
      },
    ],
  },

  {
    path: "/factories/zf/cockpits/saws/optimizer",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZF Saws optimizer" },
    children: [
      {
        name: getSubject("ZF Saws optimizer"),
        path: "",
        component: () =>
          import("src/pages/factories/zf/cockpits/saws/sawOptimizer.vue"),
      },
    ],
  },

  {
    path: "/factories/zf/settings",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZF Factory" },
    children: [
      {
        name: getSubject("ZF Settings"),
        path: "",
        component: () => import("pages/factories/zf/settings/index.vue"),
      },
    ],
  },

  {
    path: "/factories/zf/articles",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZF Articles" },
    children: [
      {
        name: getSubject("ZF Articles"),
        path: "",
        component: () => import("pages/factories/zf/articles/index.vue"),
      },
    ],
  },

  {
    path: "/factories/zf/tasks",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZF Tasks" },
    children: [
      {
        name: getSubject("ZF Tasks"),
        path: "",
        component: () => import("pages/factories/zf/tasks/index.vue"),
      },
    ],
  },

  {
    path: "/factories/zf/configuration",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZF Configuration" },
    children: [
      {
        name: getSubject("ZF Configuration"),
        path: "",
        component: () => import("pages/factories/zf/configuration/index.vue"),
      },
    ],
  },

  {
    path: "/factories/zf/panels",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZF Panels" },
    children: [
      {
        name: getSubject("ZF Panels"),
        path: "",
        component: () => import("pages/factories/zf/panels/index.vue"),
      },
    ],
  },
  {
    path: "/factories/zf/assemblyLine",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZF Assembly Line" },
    children: [
      {
        name: getSubject("ZF Assembly Line"),
        path: "",
        component: () =>
          import("src/pages/factories/zf/assemblyLine/index.vue"),
      },
    ],
  },
  {
    path: "/factories/zf/assets",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZF Assets" },
    children: [
      {
        name: getSubject("ZF Assets"),
        path: "",
        component: () => import("pages/factories/zf/assets/index.vue"),
      },
    ],
  },

  {
    path: "/factories/zf/assets/spider",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZF Spider" },
    children: [
      {
        name: getSubject("ZF Spider"),
        path: "",
        component: () => import("pages/factories/zf/assets/spider/index.vue"),
      },
    ],
  },

  {
    path: "/articles",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "Articles" },
    children: [
      {
        name: getSubject("Articles"),
        path: "",
        component: () => import("pages/articles/index.vue"),
      },
    ],
  },

  {
    path: "/planning",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "Planning" },
    children: [
      {
        name: getSubject("Planning"),
        path: "",
        component: () => import("pages/planning/index.vue"),
      },
    ],
  },

  {
    path: "/dashboards/zf/progress",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "ZF DashboardProgress" },
    children: [
      {
        name: getSubject("ZF DashboardProgress"),
        path: "",
        component: () => import("pages/dashboards/zf/progress/index.vue"),
      },
    ],
  },

  {
    path: "/handheld",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: { requiresAuth: true, subject: "Handheld" },
    children: [
      {
        name: getSubject("Handheld"),
        path: "",
        component: () => import("pages/handheld/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/zf",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: { requiresAuth: true, subject: "ZF Handheld" },
    children: [
      {
        name: getSubject("ZF Handheld"),
        path: "",
        component: () => import("pages/handheld/zf/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/zf/assembly/collo",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: {
      requiresAuth: true,
      subject: "ZF Handheld Assembly Collo",
      storeHistory: true,
    },
    children: [
      {
        name: getSubject("ZF Handheld Assembly Collo"),
        path: "",
        component: () => import("pages/handheld/zf/assembly/collo/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/zf/assembly/lintel",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: {
      requiresAuth: true,
      subject: "ZF Handheld Assembly Lintel",
      storeHistory: true,
    },
    children: [
      {
        name: getSubject("ZF Handheld Assembly Lintel"),
        path: "",
        component: () => import("pages/handheld/zf/assembly/lintel/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/zf/assembly/packaging",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: {
      requiresAuth: true,
      subject: "ZF Handheld Assembly Packaging",
      storeHistory: true,
    },
    children: [
      {
        name: getSubject("ZF Handheld Assembly Packaging"),
        path: "",
        component: () =>
          import("pages/handheld/zf/assembly/packaging/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/zf/assembly/special1",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: {
      requiresAuth: true,
      subject: "ZF Handheld Assembly Special1",
      storeHistory: true,
    },
    children: [
      {
        name: getSubject("ZF Handheld Assembly Special1"),
        path: "",
        component: () =>
          import("pages/handheld/zf/assembly/special1/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/zf/assembly/specials-overview",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: {
      requiresAuth: true,
      subject: "ZF Handheld Assembly SpecialsOverview",
      storeHistory: true,
    },
    children: [
      {
        name: getSubject("ZF Handheld Assembly SpecialsOverview"),
        path: "",
        component: () =>
          import("pages/handheld/zf/assembly/specials-overview/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/zf/assembly/specials-detail",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: {
      requiresAuth: true,
      subject: "ZF Handheld Assembly SpecialsDetail",
      storeHistory: true,
    },
    children: [
      {
        name: getSubject("ZF Handheld Assembly SpecialsDetail"),
        path: "",
        component: () =>
          import("pages/handheld/zf/assembly/specials-detail/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/zf/assembly/special2",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: {
      requiresAuth: true,
      subject: "ZF Handheld Assembly Special2",
      storeHistory: true,
    },
    children: [
      {
        name: getSubject("ZF Handheld Assembly Special2"),
        path: "",
        component: () =>
          import("pages/handheld/zf/assembly/special2/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/zf/assembly/end-cap",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: {
      requiresAuth: true,
      subject: "ZF Handheld Assembly EndCap",
      storeHistory: true,
    },
    children: [
      {
        name: getSubject("ZF Handheld Assembly EndCap"),
        path: "",
        component: () => import("pages/handheld/zf/assembly/end-cap/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/zf/assembly/bottom",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: {
      requiresAuth: true,
      subject: "ZF Handheld Assembly Bottom",
      storeHistory: true,
    },
    children: [
      {
        name: getSubject("ZF Handheld Assembly Bottom"),
        path: "",
        component: () => import("pages/handheld/zf/assembly/bottom/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/zf/assembly/top",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: {
      requiresAuth: true,
      subject: "ZF Handheld Assembly Top",
      storeHistory: true,
    },
    children: [
      {
        name: getSubject("ZF Handheld Assembly Top"),
        path: "",
        component: () => import("pages/handheld/zf/assembly/top/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/zf/assembly/rubber",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: {
      requiresAuth: true,
      subject: "ZF Handheld Assembly Rubber",
      storeHistory: true,
    },
    children: [
      {
        name: getSubject("ZF Handheld Assembly Rubber"),
        path: "",
        component: () => import("pages/handheld/zf/assembly/rubber/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/zf/assembly/stickers",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: {
      requiresAuth: true,
      subject: "ZF Handheld Assembly Stickers",
      storeHistory: true,
    },
    children: [
      {
        name: getSubject("ZF Handheld Assembly Stickers"),
        path: "",
        component: () =>
          import("pages/handheld/zf/assembly/stickers/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/zf/stations/lintel/preparePaintPP",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: {
      requiresAuth: true,
      subject: "ZF Handheld Stations Lintel PreparePaintPP",
      storeHistory: true,
    },
    children: [
      {
        name: getSubject("ZF Handheld Stations Lintel PreparePaintPP"),
        path: "",
        component: () =>
          import("pages/handheld/zf/stations/lintel/preparePaintPP/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/zf/stations/lintel/preparePP",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: {
      requiresAuth: true,
      subject: "ZF Handheld Stations Lintel PreparePP",
      storeHistory: true,
    },
    children: [
      {
        name: getSubject("ZF Handheld Stations Lintel PreparePP"),
        path: "",
        component: () =>
          import("pages/handheld/zf/stations/lintel/preparePP/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/zh/mabo-buffer-pp",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: { requiresAuth: true, subject: "ZH Handheld Stations Mabo BufferPP" },
    children: [
      {
        name: getSubject("ZH Handheld Stations Mabo BufferPP"),
        path: "",
        component: () =>
          import("pages/handheld/zh/stations/mabo-buffer-pp/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/zh/mabo-infeed1",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: { requiresAuth: true, subject: "ZH Handheld Infeed1" },
    children: [
      {
        name: getSubject("ZH Handheld Infeed1"),
        path: "",
        component: () =>
          import("pages/handheld/zh/stations/mabo-infeed1/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/zh/mabo-infeed2",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: { requiresAuth: true, subject: "ZH Handheld Infeed2" },
    children: [
      {
        name: getSubject("ZH Handheld Infeed2"),
        path: "",
        component: () =>
          import("pages/handheld/zh/stations/mabo-infeed2/index.vue"),
      },
    ],
  },

  {
    path: "/handheld/ee/stations/profiling/:stationId/:substationId",
    component: () => import("layouts/HandheldLayout.vue"),
    meta: {
      requiresAuth: true,
      subject: "EE Handheld Profiling",
      storeHistory: true,
    },
    children: [
      {
        name: getSubject("EE Handheld Profiling"),
        path: "",
        component: () =>
          import("pages/handheld/ee/stations/profiling/index.vue"),
      },
    ],
  },

  {
    path: "/settings",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "Settings" },
    children: [
      {
        name: getSubject("DefaultPlanning"),
        path: "/settings/defaultPlanning",
        component: () => import("pages/settings/defaultPlanning/index.vue"),
      },
      {
        name: getSubject("Devices"),
        path: "/settings/devices",
        component: () => import("pages/settings/devices/index.vue"),
      },
      {
        name: getSubject("Templates"),
        path: "/settings/templates",
        children: [
          {
            name: getSubject("StickerTemplates"),
            path: "/settings/templates/sticker",
            component: () =>
              import("pages/settings/templates/sticker/index.vue"),
          },
        ],
      },
      {
        name: getSubject("Tokens"),
        path: "/settings/tokens",
        component: () => import("pages/settings/tokens/index.vue"),
      },
      {
        name: getSubject("Users"),
        path: "/settings/users",
        component: () => import("pages/settings/users/index.vue"),
      },
    ],
  },

  {
    path: "/photos",
    component: () => import("layouts/MainLayout.vue"),
    meta: { requiresAuth: true, subject: "Photos" },
    children: [
      {
        name: getSubject("Photos"),
        path: "",
        component: () => import("src/pages/photos/index.vue"),
      },
    ],
  },

  {
    name: getSubject("Forbidden"),
    path: "/error/403",
    meta: { requiresAuth: false, subject: "Forbidden" },
    component: () => import("pages/Error403.vue"),
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: "/:catchAll(.*)*",
    component: () => import("pages/Error404.vue"),
  },
];

export default routes;
